import { useEffect, useState } from "react"
import Modal from "../../../components/base/Modal"
import { closeChatRename, useHub } from "../../../core/Global"
import ChatContactItem from "../models/ChatContactItem"
import { API_ROUTES } from "../../../core/Constants"
import FlexRow from "../../../components/base/FlexRow"
import Icon from "../../../components/base/Icon"
import TextBox from "../../../components/form/TextBox"


interface IProps {
    chat: ChatContactItem
}

export default function ChatRenameModal(props: IProps) {

    const hub = useHub()


    return (
        <Modal id="modal-chat-rename"
            title="Rename Chat"
            open visible staticBackdrop
            onClose={closeChatRename}
            buttonText="Update Chat Title"
            onSubmit={(body, callback) => {
                hub.Post(API_ROUTES.Chat + "rename/" + props.chat.chatId, body, res => {
                    if (res.success) {

                    }
                    callback!(res)
                })
            }}>
            <div>

                {
                    props.chat.tech &&
                    <FlexRow className="mb-5 border-bottom pb-3">
                        <span className="me-2">
                            <Icon icon="user-helmet-safety" size={18} />
                        </span>
                        <span className="fw-boldest fs-5">
                            {props.chat.tech.fullName}
                        </span>
                    </FlexRow>
                }

                <TextBox name="title" value={props.chat.title} block labelUp label="Chat Title" />



            </div>
        </Modal>
    )
}